import {
  Directive,
  EmbeddedViewRef,
  inject,
  TemplateRef,
  ViewContainerRef
} from "@angular/core";

@Directive({
  selector: "[pageDatagridColumnCellTemplate]",
  standalone: false
})
export class PageDatagridColumnCelltemplateDirective {
  readonly #embeddedViewRefMap: Record<
    string,
    EmbeddedViewRef<unknown & { row: unknown }>
  > = {};

  readonly #templateRef = inject(TemplateRef<any>);
  readonly #viewContainerRef = inject(ViewContainerRef);

  render(renderData: {
    container: HTMLElement;
    row: unknown & { id: string };
  }): Node | undefined {
    const key: string = renderData.row["id"];

    let embeddedViewRef = this.#embeddedViewRefMap[key];

    if (!embeddedViewRef) {
      embeddedViewRef = this.#viewContainerRef.createEmbeddedView(
        this.#templateRef,
        {
          row: renderData.row
        }
      );
    } else {
      embeddedViewRef.context.row = renderData.row;
      embeddedViewRef.markForCheck();
    }

    if (renderData.container) {
      renderData.container.append(embeddedViewRef.rootNodes[0]);
    }

    this.#embeddedViewRefMap[key] = embeddedViewRef;

    return embeddedViewRef.rootNodes[0];
  }

  static ngTemplateContextGuard(
    directive: PageDatagridColumnCelltemplateDirective,
    context: unknown
  ): context is { row: any } {
    return true;
  }
}
